// Components
import TextComponent from '@/components/text/component'
import PaymentTermsComponent from '@/components/payment-terms/component'
import ImageTextComponent from '@/components/image-text/component'

// The index page is the first page the user reaches when navigating to the site, residing under the root ("/") URL.
export default {
  name: 'general-terms',
  components: { TextComponent, PaymentTermsComponent, ImageTextComponent },
  mounted () {
    const anchor = this.$router.currentRoute.hash
    this.$nextTick(() => {
      if (anchor && document.querySelector(anchor)) {
        location.href = anchor
      }
    })
  },
  computed: {
    isQliroEnabled () {
      const hostname = window.location.hostname.toLowerCase()
      const [ topDomain ] = hostname.match(/(localhost|\.\w{2,4}$)/gm)
      return ['.se'].indexOf(topDomain) > -1 && this.$store.getters.currency.currency === 'SEK'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/about/general-terms/script.js